// extracted by mini-css-extract-plugin
export default {"modal":"Onboarding--modal--L0tZK"};